package br.com.texeratx.boardgametimeapp.domain.usecases.upload

import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository

class UploadUserImageUseCase(
    private val repo: UploadRepository
) {
    suspend operator fun invoke(
        bytes: ByteArray,
        fileName: String,
        mimeType: String
    ): Result<String> = repo.uploadUserImage(bytes, fileName, mimeType)
}
